// import PageController from "./PageController";
import React, { createContext, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";

import "react-toastify/dist/ReactToastify.css";
import Routing from "./routes/Routing";
// import { render } from "enzyme";

export const UserContext = createContext(null);

function App() {
  const [user, setUser] = useState("");

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <Routing />
    </UserContext.Provider>
  );
}

export default App;
